import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { Toaster } from 'sonner';
import { AuthProvider, useAuth } from './auth';
import './i18n';
import { router } from './router';
import './styles.css';

// The shared theme keys its colours off data-theme; FarmAI follows the phone's setting.
const dark = window.matchMedia('(prefers-color-scheme: dark)');
const applyTheme = () => (document.documentElement.dataset.theme = dark.matches ? 'dark' : 'light');
applyTheme();
dark.addEventListener('change', applyTheme);

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: true } },
});

function App() {
  const auth = useAuth();
  useEffect(() => {
    if (!auth.loading) void router.invalidate();
  }, [auth.loading, auth.session]);
  if (auth.loading) return <div className="skeleton m-auto mt-[40dvh] h-10 w-40" />;
  return <RouterProvider router={router} context={{ auth }} />;
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <App />
        <Toaster position="top-center" richColors dir="auto" />
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
